<template lang="html">
  <div class="">
    <vue-cal
    hide-view-selector :time="false" default-view="month"
    events-on-month-view="short"
    events-count-on-year-view
    :disable-views="['week', 'day']"
    :events="events"
    @cell-click="dayClick"
    @view-change="changeView"
    ref="vuecal"  >
  </vue-cal>
  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
const flatten = require('array-flatten')

export default {
  name: 'MonthView',
  components: {
    'vue-cal': VueCal
  },
  data() {
    return {
      todayDate: new Date().dateString(),
      calView: 'month',
      metrics: require('../../sampledata/metric_file.json'),
    }
  },
  computed: {
    events: function() {
      var arr = []

      for (var entry in this.$parent.journal.entries) {
        if (this.$parent.journal.entries.hasOwnProperty(entry)) {
          entry = this.$parent.journal.entries[entry]
          arr.push({
            start: entry.forDay,
            end: entry.forDay,
            title: 'Entry Written',
            class: 'service journalisr fas-icon'
          })
        }
      }

      // const maxMetrics = 1
      // for (var date in this.metrics) {
      //   if (this.metrics.hasOwnProperty(date)) {
      //     var dateObject = this.metrics[date],
      //       services = Object.keys(dateObject),
      //       dateCount = flatten(Object.values(dateObject)).length
      //
      //     if (dateCount == 0) continue;
      //     var service = services[Math.floor(Math.random() * services.length)]
      //     var metric = dateObject[service][Math.floor(Math.random() * dateObject[service].length)]
      //     arr.push({
      //       start: date,
      //       end: date,
      //       title: metric,
      //       class: 'service ' + service
      //     })
      //   }
      // }
      return arr
    }
  },
  methods: {
    randInt(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    dayClick(date) {
      if (this.calView == 'month') {
        this.$parent.openEditorToDate(date)
      }
    },
    changeView(data) {
      this.calView = data.view
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/styles/metrics/month';
</style>
<style lang="css">
.vuecal__cell-events-count {
  width: 4px;
  min-width: 0;
  height: 4px;
  padding: 0;
  color: transparent;
}
.vuecal--month-view .vuecal__event-title::before {
  display: inline-block;
  font-family: "Font Awesome 5 Brands";
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  padding: 0.15em 0.25em;
  text-align: center;
  width: 1.3em;
  -webkit-font-smoothing: antialiased;
}

@-webkit-keyframes shadow-pop-br{0%{-webkit-box-shadow:0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e;box-shadow:0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e;-webkit-transform:translateX(0) translateY(0);transform:translateX(0) translateY(0)}100%{-webkit-box-shadow:1px 1px #3e3e3e,2px 2px #3e3e3e,3px 3px #3e3e3e,4px 4px #3e3e3e,5px 5px #3e3e3e,6px 6px #3e3e3e,7px 7px #3e3e3e,8px 8px #3e3e3e;box-shadow:1px 1px #3e3e3e,2px 2px #3e3e3e,3px 3px #3e3e3e,4px 4px #3e3e3e,5px 5px #3e3e3e,6px 6px #3e3e3e,7px 7px #3e3e3e,8px 8px #3e3e3e;-webkit-transform:translateX(-8px) translateY(-8px);transform:translateX(-8px) translateY(-8px)}}@keyframes shadow-pop-br{0%{-webkit-box-shadow:0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e;box-shadow:0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e,0 0 #3e3e3e;-webkit-transform:translateX(0) translateY(0);transform:translateX(0) translateY(0)}100%{-webkit-box-shadow:1px 1px #3e3e3e,2px 2px #3e3e3e,3px 3px #3e3e3e,4px 4px #3e3e3e,5px 5px #3e3e3e,6px 6px #3e3e3e,7px 7px #3e3e3e,8px 8px #3e3e3e;box-shadow:1px 1px #3e3e3e,2px 2px #3e3e3e,3px 3px #3e3e3e,4px 4px #3e3e3e,5px 5px #3e3e3e,6px 6px #3e3e3e,7px 7px #3e3e3e,8px 8px #3e3e3e;-webkit-transform:translateX(-8px) translateY(-8px);transform:translateX(-8px) translateY(-8px)}}

.vuecal--month-view .vuecal__event.service.journalisr {
  /* border: rgb(0, 0, 0) 2px solid; */
  /* padding: 5px 0; */
  /* position: absolute;
  transform: translateY(-125%); */
  animation: shadow-pop-br 0.5s both reverse;
  animation-delay: 0.2s;
}
.vuecal--month-view .fas-icon .vuecal__event-title::before {
  font-family: 'Font Awesome\ 5 Free';
  font-weight: 900;
}

.vuecal--month-view .vuecal__event.service {
  width: calc(100% - 10px);
  margin: 5px;
}

.vuecal--month-view .vuecal__cell {
  /* height: 16.7%; */
  /* flex:0.5; */
  /* align-self: stretch; */
  cursor: pointer;
}
/* .vuecal--month-view .vuecal__cell[entry] {
    background-image: linear-gradient(135deg, var(--shade0) -1px, var(--shade0) 15px, transparent 16px, transparent) !important;
    background-repeat: no-repeat !important;
} */
.vuecal--month-view .vuecal__cell:hover .vuecal__cell-content {
  transition: .4s;
}
.vuecal--month-view .vuecal__cell:hover .vuecal__cell-content {
  filter: blur(2px);
  transition: .4s;
  z-index: 12;
}
.vuecal--month-view .vuecal__cell::before {
  content: '\00a0Write →';
  white-space: pre-wrap;
  display: flex;
  flex: auto;
  justify-content: center;
  align-items: center;
  vertical-align: bottom;
  color: rgba(0,0,0,0);
  transition: .4s;
  z-index: 11;
}
.vuecal--month-view .vuecal__cell:hover::before {
  color: rgba(0,0,0,1);
  background: rgba(221, 221, 221, 0.5);
  transition: .4s;
}
.vuecal--month-view .vuecal__cell-content {
  justify-content: space-between;
  height: 100%;
  align-items: flex-end;
  /* margin: 10px; */
}

.vuecal--month-view .vuecal__cell-date {
  padding: 4px;
}

.vuecal--month-view .vuecal__no-event {
  display: none;
}
.vuecal__cell.selected {
  z-index: 1;
}
</style>
